import { useEffect, useState } from "react";

const CONSULTA = "(max-width: 767px)";

/** true en pantallas chicas. Preferir clases responsive de Tailwind; usar esto sólo si cambia la estructura. */
export function useIsMobile(): boolean {
  const [esMobile, setEsMobile] = useState(() => window.matchMedia?.(CONSULTA).matches ?? false);
  useEffect(() => {
    const mql = window.matchMedia?.(CONSULTA);
    if (!mql) return;
    const alCambiar = (e: MediaQueryListEvent) => setEsMobile(e.matches);
    mql.addEventListener("change", alCambiar);
    return () => mql.removeEventListener("change", alCambiar);
  }, []);
  return esMobile;
}
